<script setup>
import { computed } from 'vue';
import Draggable from 'vuedraggable';
import KanbanCard from './KanbanCard.vue';

const props = defineProps({
  stage: {
    type: Object,
    required: true,
  },
  items: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['change', 'add']);

// O vuedraggable exige v-model; a mutação real acontece na store via @change,
// então o setter local é ignorado de propósito.
const draggableItems = computed({
  get: () => props.items,
  set: () => {},
});

const onChange = event => emit('change', props.stage.id, event);
</script>

<template>
  <div
    class="flex flex-col flex-shrink-0 w-72 max-h-full rounded-xl bg-n-slate-2 dark:bg-n-solid-1 border border-n-weak"
  >
    <div class="flex items-center gap-2 px-3 py-2.5 border-b border-n-weak">
      <span
        class="size-[10px] rounded-full flex-shrink-0"
        :style="{ backgroundColor: stage.color }"
      />
      <span class="text-sm font-semibold truncate text-n-slate-12">
        {{ stage.name }}
      </span>
      <span
        class="px-1.5 py-0.5 ml-auto text-xs rounded-md bg-n-slate-3 text-n-slate-11"
      >
        {{ items.length }}
      </span>
      <button
        class="flex items-center justify-center rounded-md size-6 text-n-slate-11 hover:bg-n-slate-3 hover:text-n-slate-12"
        :title="$t('PIPELINE.ADD_CARD.BUTTON')"
        @click="emit('add', stage.id)"
      >
        <span class="i-lucide-plus size-4" />
      </button>
    </div>
    <Draggable
      v-model="draggableItems"
      class="flex flex-col flex-1 gap-2 p-2 overflow-y-auto min-h-[80px]"
      group="pipeline-cards"
      item-key="id"
      animation="200"
      ghost-class="kanban-ghost"
      @change="onChange"
    >
      <template #item="{ element }">
        <KanbanCard :item="element" />
      </template>
    </Draggable>
  </div>
</template>

<style scoped>
.kanban-ghost {
  @apply opacity-50 ring-2 ring-n-blue-9 rounded-lg;
}
</style>
